<template>
  <div class="toolbar">
    <div class="left">
      <User />
      <Cycle class="cycle" />
      <quarter-cycle
        class="cycle"
        v-bind="$attrs"
      />
    </div>
    <div class="right">
      <a-button
        class="button"
        @click="switchAllOrCurrent"
      >
        {{ allOrCurrent === 'ALL' ? $t('weekly.current') : $t('weekly.all') }}
      </a-button>
      <a-button
        class="button"
        @click="jumpToRegularMode"
      >
        {{ $t('weekly.originalMode') }}
      </a-button>
    </div>
  </div>
</template>
<script>
import User from '@/views/OkrList/User'
import Cycle from '@/components/Cycle'
import QuarterCycle from './quarter-cycle.vue'
import { useRouter } from 'vue-router'
export default {
  components: {
    User,
    Cycle,
    QuarterCycle
  },
  props: {
    userId: {
      type: [Number, String],
      default: undefined
    },
    allOrCurrent: {
      type: String,
      default: 'ALL'
    }
  },
  emits: ['update:allOrCurrent'],
  setup (props, { emit }) {
    const router = useRouter()
    const jumpToRegularMode = () => {
      if (props.userId) {
        router.push(`/users/${props.userId}/okr`)
      } else {
        router.push('/okr')
      }
    }

    const switchAllOrCurrent = () => {
      if (props.allOrCurrent === 'ALL') {
        emit('update:allOrCurrent', 'CURRENT')
      } else {
        emit('update:allOrCurrent', 'ALL')
      }
    }
    return {
      jumpToRegularMode,
      switchAllOrCurrent
    }
  }
}
</script>
<style lang="less" scoped>
.toolbar {
  padding: 16px 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cycle {
  margin-left: 40px;
}

.left {
  display: flex;
  align-items: center;
}

.button {
  margin-left: 8px;
}
</style>
